import { CountryCodeSelector } from '@/helpers/CountryCodeSelector';
import { Button,  Col, DatePicker,  Row } from 'antd';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { partnerSignup } from '@/actions/auth';

const PartnerSignupComponent = () => {
  const [data, setData] = useState({
    register_name: '',
    country: '',
    city: '',
    street: '',
    established_date: '',
    contact_person_first_name: '',
    contact_person_last_name: '',
    contact_person_email: '',
    contact_person_phone_number: '',
    contact_person_country_code: '+977',
    password: '',
    confirm_password: '',
  });
  const [passwordError, setPasswordError] = useState('');
  const [dateError, setDateError] = useState('');

  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.auth.creds);

  useEffect(() => {
    if (data.password !== data.confirm_password) {
      setPasswordError("Password doesn't match");
    } else {
      setPasswordError('');
    }
  }, [data.confirm_password, data.password]);

  const handleSubmit = (event) => {
    if (!data?.established_date) {
      setDateError('This field is required');
    } else {
      event.preventDefault();
      dispatch(partnerSignup(data));
    }
  };

  return (
    <Row className="my-2" justify="center">
      <Col
        sm={{ span: 16 }}
        style={{ backgroundColor: '#f7f7f9', borderRadius: 8 }}
        className=" shadow-none p-4 gutter-row mb-4"
      >
        <h3>Recruitment Partner</h3>
        <form id="contactForm" className="mt-0 pt-2" onSubmit={handleSubmit}>
          {typeof userData?.message === 'string' && userData?.message && (
            <div className="alert alert-danger">
              <p>{userData?.message}</p>
            </div>
          )}
          <div className="form-row">
            <div className=" col-lg-12 col-md-12">
              <div className="form-group">
                <input
                  value={data.register_name}
                  onChange={(e) =>
                    setData({ ...data, register_name: e.target.value })
                  }
                  type="text"
                  className="form-control w-100"
                  placeholder="Your Company Name"
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input
                  value={data.contact_person_first_name}
                  onChange={(e) =>
                    setData({ ...data, contact_person_first_name: e.target.value })
                  }
                  type="text"
                  className="form-control w-100"
                  placeholder="Your First Name"
                  required
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input
                  value={data.contact_person_last_name}
                  onChange={(e) =>
                    setData({ ...data, contact_person_last_name: e.target.value })
                  }
                  type="text"
                  className="form-control w-100"
                  placeholder="Your Last Name"
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <input
                  type="email"
                  value={data.contact_person_email}
                  onChange={(e) =>
                    setData({ ...data, contact_person_email: e.target.value })
                  }
                  className="form-control w-100"
                  placeholder="Email"
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <input
                  type="text"
                  value={data.country}
                  onChange={(e) => setData({ ...data, country: e.target.value })}
                  className="form-control w-100"
                  placeholder="Country"
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input
                  type="text"
                  value={data.city}
                  onChange={(e) => setData({ ...data, city: e.target.value })}
                  className="form-control w-100"
                  placeholder="City"
                  required
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input
                  type="text"
                  value={data.street}
                  onChange={(e) => setData({ ...data, street: e.target.value })}
                  className="form-control w-100"
                  placeholder="Street"
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-6 col-md-12">
              <div className="form-row">
                <div className="col-lg-4 col-md-12 mb-2">
                  <CountryCodeSelector
                    onChange={(val) => {
                      setData({ ...data, contact_person_country_code: val });
                    }}
                    defaultValue={'+977'}
                  />
                </div>
                <div className="col-lg-8 col-md-12">
                  <div className="form-group">
                    <input
                      type="number"
                      value={data.contact_person_phone_number}
                      onChange={(e) =>
                        setData({
                          ...data,
                          contact_person_phone_number: e.target.value,
                        })
                      }
                      className="form-control w-100"
                      placeholder="Phone Number"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <DatePicker
                  autoComplete="off"
                  format={'YYYY-MM-DD'}
                  picker="date"
                  className="w-100"
                  placeholder="Select established Date"
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  clearIcon={false}
                  onChange={(value) => {
                    setDateError('');
                    setData({
                      ...data,
                      established_date: moment(value).format('YYYY-MM-DD'),
                    });
                  }}
                  style={{
                    height: '45px',
                    borderColor: `${dateError ? 'red' : '#e7e9f1'}`,
                    borderRadius: '6px',
                    boxShadow: 'none',
                  }}
                />
                {dateError && (
                  <span className="validation mb-2">
                    <i className="fas fa-exclamation-triangle"></i> {dateError}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input
                  autoComplete="off"
                  type="password"
                  value={data.password}
                  onChange={(e) => setData({ ...data, password: e.target.value })}
                  className="form-control w-100"
                  placeholder="Password"
                  required
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input
                  autoComplete="new-password"
                  type="password"
                  value={data.confirm_password}
                  onChange={(e) =>
                    setData({ ...data, confirm_password: e.target.value })
                  }
                  className="form-control w-100"
                  style={{ borderColor: `${passwordError ? 'red' : ''}` }}
                  placeholder="Confirm Password"
                  required
                />
                {passwordError && (
                  <span className="validation mb-2">
                    <i className="fas fa-exclamation-triangle"></i> {passwordError}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="float-right">
            <Button className="btn-primary " size="large" htmlType="submit">
              Sign up
            </Button>
          </div>
        </form>
      </Col>
    </Row>
  );
};

export default PartnerSignupComponent;
